/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */
import type {
  ComplaintFilters,
  ComplaintSummary,
  HasOpenComplaintOnAccountParams,
} from "../model"

import { backofficeRequest } from "../../client"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary Returns complaint summary based on the filters applied
 */
export const getComplaintsSummary = (
  complaintFilters: ComplaintFilters,
  options?: SecondParameter<typeof backofficeRequest<ComplaintSummary>>,
) => {
  return backofficeRequest<ComplaintSummary>(
    {
      url: `/complaints/summary`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: complaintFilters,
    },
    options,
  )
}
/**
 * @summary Returns whether the provided account has an open complaint on it
 */
export const hasOpenComplaintOnAccount = (
  params: HasOpenComplaintOnAccountParams,
  options?: SecondParameter<typeof backofficeRequest<boolean>>,
) => {
  return backofficeRequest<boolean>(
    { url: `/complaints/open`, method: "GET", params },
    options,
  )
}
export type GetComplaintsSummaryResult = NonNullable<
  Awaited<ReturnType<typeof getComplaintsSummary>>
>
export type HasOpenComplaintOnAccountResult = NonNullable<
  Awaited<ReturnType<typeof hasOpenComplaintOnAccount>>
>
